import createStore from '../../libs/create-store'

import { TFilterCollection } from '../types/table-props'
import { TTableStore } from '../types/table-store'

export const createTableStore = <T>(tableStore: TTableStore<T>) => {
    const newStore = createStore<TTableStore<T>>(tableStore)

    const update = (newData: Partial<TTableStore<T>>) => {
        newStore.set({
            ...newStore.get(),
            ...newData,
        })
    }

    return {
        ...newStore,
        update,
        /** Replaces the filters and goes back to the first page in a single store update. */
        setFilters: (update: TFilterCollection) => {
            const current = newStore.get()
            newStore.set({
                ...current,
                filters: update,
                pagination:
                    current.pagination.page === 0
                        ? current.pagination
                        : { ...current.pagination, page: 0 },
            })
        },
        /** Replaces rows with the same id, prepends the new ones. */
        setRow: (rows: T | T[], id: keyof T) => {
            const { data, total } = newStore.get()

            let newData: T[] = [...data]
            let newTotal = total

            for (const row of Array.isArray(rows) ? rows : [rows]) {
                if (newData.some(item => item[id] == row[id])) {
                    newData = newData.map(item => (item[id] == row[id] ? row : item))
                }
                else {
                    newTotal += 1
                    newData = [row, ...newData]
                }
            }

            update({ data: newData, total: newTotal })
            return newData
        },
        removeRow: (row: T, id: keyof T) => {
            const { data, total, selectedRows } = newStore.get()
            if (!data.some(item => item[id] === row[id]))
                return

            const newSelectedRows = new Map(selectedRows)
            newSelectedRows.delete(row[id] as string | number)

            update({
                data: data.filter(item => item[id] !== row[id]),
                total: total - 1,
                selectedRows: selectedRows.has(row[id] as string | number) ? newSelectedRows : selectedRows,
            })
        },
    }
}

export type TTableStoreApi<T> = ReturnType<typeof createTableStore<T>>
